import React from 'react'
import InputField from '../../CommonUtils/InputFeild'

const MessageA14c = (props) => {
  return (
    <div>
      <InputField {...props} />
    </div>
  )
}

export default MessageA14c
